import React from 'react';

const PatientListSkeleton = ({ count = 8 }) => (
    <div className="patient-files-table-wrap" aria-hidden="true">
        {Array.from({ length: count }).map((_, index) => (
            <div key={`patient-files-skeleton-${index}`} className="patient-files-skeleton-row">
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-long" />
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-medium" />
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-short" />
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-long" />
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-medium" />
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-short" />
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-short" />
                <div className="patient-files-skeleton-block patient-files-skeleton-block--cell-short" />
            </div>
        ))}
    </div>
);

export default PatientListSkeleton;
